export type AlgorithmType = "BruteForce" | "Milp";

export const ALGORITHM_OPTIONS: readonly {
  label: string;
  value: AlgorithmType;
}[] = [
  { label: "Local search (v1)", value: "BruteForce" },
  { label: "MILP (v2)", value: "Milp" },
];

export function algorithmLabel(value: AlgorithmType): string {
  return (
    ALGORITHM_OPTIONS.find((option) => option.value === value)?.label ?? value
  );
}
